import { t } from "i18next";
import "../../Style/form-submit/health.css";
import QuestionAgreeWidget from "../../Widgets/question-yesno-answer/QuestionAgreeWidget";
import QuestionYesNoAnswerWidget from "../../Widgets/question-yesno-answer/QuestionYesNoAnswerWidget";
import { useEffect, useState } from "react";
import QuestionDetailsYesNoAnswerWidget from "../../Widgets/question-yesno-answer/QuestionDetailsYesNoAnswerWidget";
import { isNullOrEmpty, removeDotFromStringMoney } from "../../Services/service";
function HealthAssessmentSection({ objectDto, setObjectDto, setState }) {
  const [mobile, setMobile] = useState(false);
  const [questionsInfo, setQuestionsIno] = useState([
    {
      id: "q1",
      flag: null,
      text: "Bạn đã từng được chẩn đoán mắc bất kỳ bệnh nào sau đây: ung thư, khối u/bướu/nang/polyp, tiểu đường, huyết áp cao, bệnh van tim, bệnh cơ tim, bệnh mạch vành, thiếu máu cơ tim, nhồi máu cơ tim, suy tim, đột quỵ, tai biến mạch não, viêm gan B/C, xơ gan, suy gan, nghiện rượu, viêm tụy mạn, viêm cầu thận, thận đa nang, hội chứng thận hư, suy thận, bệnh phổi tắc nghẽn mãn tính, xơ phổi, xơ nang phổi, bệnh tủy xương, suy giảm trí nhớ, sa sút trí tuệ, Alzheimer, Parkinson, bệnh loạn dưỡng cơ?",
    },
    {
      id: "q2",
      flag: null,
      text: "Trong 12 tháng vừa qua, bạn đã từng nằm viện quá 7 ngày liên tục và/hoặc đã từng điều trị quá 10 ngày liên tục?",
    },
    {
      id: "q3",
      flag: null,
      text: "Trong 6 tháng vừa qua, bạn có bị giảm cân nặng quá 3 kg (ngoại trừ lý do ăn kiêng), có nổi hạch bất thường, có đi tiểu ra máu và/hoặc đi cầu ra máu?",
    },
    {
      id: "q4",
      flag: null,
      text: "Hiện tại, bạn có được tư vấn, có dự định, và có bất kỳ dấu hiệu hoặc triệu chứng nào, khiến cần phải gặp bác sĩ để được khám, xét nghiệm, theo dõi và/hoặc điều trị?",
    },
  ]);
  const [questionFatca, setQuestionFatca] = useState({
    flag: null,
    text: "Bạn có phải là công dân Hoa Kỳ hoặc là người có nghĩa vụ thuế đối với Hoa Kỳ hoặc có ít nhất 1 trong các yếu tố sau:",
    details: [
      "Có hộ chiếu tại Hoa Kỳ, hoặc có nơi sinh tại Hoa Kỳ, hoặc",
      "Mã số thuế tại Hoa Kỳ, hoặc",
      "Các giấy tờ cư trú ở Hoa Kỳ, địa chỉ gửi thư hoặc nơi cư trú hiện hành ở Hoa Kỳ (bao gồm hộp nhận thư ở bưu điện Hoa Kỳ), số điện thoại hiện hành tại Hoa Kỳ, hoặc giấy ủy quyền thông qua luật sư hoặc giấy cho phép toàn quyền đã ký tên đang có hiệu lực cấp cho người có địa chỉ ở Hoa Kỳ.",
    ],
  });
  const [questionsConfirm, setQuestionsConfirm] = useState([
    {
      id: "q1",
      flag: null,
      text: [
        "Tôi là công dân có quốc tịch Việt Nam, đang sinh sống tại Việt Nam.",
        "Tôi là Bên mua bảo hiểm đồng thời cũng là Người được bảo hiểm của Hợp đồng bảo hiểm.",
        "Tôi hiểu rằng Phú Hưng Life có thể xem xét lại việc phát hành, duy trì hiệu lực Hợp đồng bảo hiểm này nếu thông tin kê khai là không chính xác.",
        "Tôi đồng ý tham gia bảo hiểm qua giao dịch điện tử với Phú Hưng Life, đã đọc, hiểu và đồng ý với Quy tắc và Điều khoản sản phẩm Phú Bảo An Gia 2.0.",
      ],
    },
  ]);
  useEffect(() => {
    var check = true;
    questionsConfirm.map((item) => {
      if (item.flag === null) check = false;
    });
    if (questionFatca.flag === null) check = false;

    questionsInfo.map((item) => {
      if (item.flag === null) check = false;
    });
    if (check) {
      if(objectDto.step === 2) setState(true);
      var flagConfirm = true;
      questionsConfirm.map((item) => {
        if (item.flag === false) flagConfirm = false;
      });
      var flagInfo = true;
      questionsInfo.map((item) => {
        if (item.flag === true) flagInfo = false;
      });
      setObjectDto({...objectDto, flagConfirm: flagConfirm, flagFatca: !questionFatca.flag, flagInfo: flagInfo});
    }else{
      setState(false);
    }
  }, [questionsConfirm, questionFatca, questionsInfo]);
  useEffect(()=>{
    const pageWidth = document.documentElement.scrollWidth;
    if(pageWidth <= 768) setMobile(true);
    else setMobile(false);
  },[window.innerWidth])
  return (
    <section className="health-assessment">
      <div className="health-assessment-wrapper">
        <div className="health-form">
          <div className="title-health-wrap">
            <h2 className="title-font-health">
              <strong>{t("productinformation")}</strong>
            </h2>
          </div>
          <div className="border-form-list">
            <div className="border-form">
              <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                {t("product")}
              </span>
              <span className="col-md-12 col-sm-12 col-xs-12 value-form">
                {objectDto.description + " - " + objectDto.productName}
              </span>
            </div>
            <div className="border-form">
              <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                {t("moneypolicy")}
              </span>
              <span className="col-md-12 col-sm-12 col-xs-12 value-form">
                {objectDto.strSumAssured}
                
              </span>
            </div>
            <div className="border-form">
              <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                {t("feepolicy")}
              </span>
              <span className="col-md-12 col-sm-12 col-xs-12 value-form">
                {
                  !isNullOrEmpty(objectDto.discount) && objectDto.discount > 0 ?
                  ( <>
                      <span className="old-premium">
                        {removeDotFromStringMoney(objectDto.premiumOrigin)}{" "}
                        {t("vnd")}
                        {t("peryear")}
                      </span>
                      <span className="split-premium">{" "}</span>
                      <span className="new-premium">
                        {removeDotFromStringMoney(objectDto.premium)}{" "}
                        {t("vnd")}
                        {t("peryear")}
                      </span>
                    </>
                  ) :
                  <span className="col-md-12 col-sm-12 col-xs-12 value-form">
                    {removeDotFromStringMoney(objectDto.premium)}
                    {" "} 
                    {t("vnd")}
                    {t("peryear")}
                  </span>
                }
              </span>
            </div>
          </div>

          <div className="title-health-wrap">
            <h2 className="title-font-health">
              <strong>{t("healthinfotitle")}</strong>
            </h2>
          </div>
              <QuestionYesNoAnswerWidget
                questions={questionsInfo}
                isMobile={mobile}
                setQuestions={setQuestionsIno}
              />
              <div className="title-health-wrap">
                <h2 className="title-font-health">
                  <strong>{t("fatcainfortitle")}</strong>
                </h2>
              </div>
              <QuestionDetailsYesNoAnswerWidget
                question={questionFatca}
                isMobile={mobile}
                setQuestion={setQuestionFatca}
              />

              <div className="title-health-wrap">
                <h2 className="title-font-health">
                  <strong>{t("pleaseconfirmtitle")}</strong>
                </h2>
              </div>
              <QuestionAgreeWidget
                questions={questionsConfirm}
                isMobile={mobile}
                setQuestions={setQuestionsConfirm}
              />
        </div>
      </div>
    </section>
  );
}
export default HealthAssessmentSection;
